/**
 * Gets a data attribute value from the current script or any element with the attribute
 * @param attr - The attribute name (without the data-cya11y- prefix)
 * @returns The attribute value or null if not found
 */
export function getScriptDataAttribute(attr: string): string | null {
  if (!attr || typeof attr !== 'string') {
    console.warn('Invalid attribute name provided to getScriptDataAttribute:', attr);
    return null;
  }

  const key = `data-cya11y-${attr}`;

  try {
    // First try to get from current script
    const script = document.currentScript;
    if (script?.hasAttribute(key)) {
      return script.getAttribute(key);
    }
    
    // Fallback to querying any element with the attribute
    const element = document.querySelector(`[${key}]`);
    return element?.getAttribute(key) || null;
  } catch (error) {
    console.error('Error getting script data attribute:', error);
    return null;
  }
}